import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function CustomCursor() {
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  const [isHovering, setIsHovering] = useState(false);
  useEffect(() => {
    const updateMousePosition = (e: MouseEvent) => {
      setMousePosition({
        x: e.clientX,
        y: e.clientY
      });
    };
    const handleMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName.toLowerCase() === 'a' || target.tagName.toLowerCase() === 'button' || target.closest('a') || target.closest('button') || target.classList.contains('hover-target')) {
        setIsHovering(true);
      } else {
        setIsHovering(false);
      }
    };
    window.addEventListener('mousemove', updateMousePosition);
    window.addEventListener('mouseover', handleMouseOver);
    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
      window.removeEventListener('mouseover', handleMouseOver);
    };
  }, []);
  return <>
      {/* Main dot */}
      <motion.div className="fixed top-0 left-0 w-2 h-2 bg-gold rounded-full pointer-events-none z-[10000] mix-blend-difference" animate={{
      x: mousePosition.x - 4,
      y: mousePosition.y - 4,
      scale: isHovering ? 0 : 1
    }} transition={{
      type: 'tween',
      ease: 'backOut',
      duration: 0.1
    }} data-id="element-66" />
      {/* Outer ring */}
      <motion.div className="fixed top-0 left-0 w-8 h-8 border border-gold rounded-full pointer-events-none z-[10000] mix-blend-difference flex items-center justify-center" animate={{
      x: mousePosition.x - 16,
      y: mousePosition.y - 16,
      scale: isHovering ? 1.5 : 1,
      backgroundColor: isHovering ? 'rgba(201, 169, 110, 0.1)' : 'rgba(201, 169, 110, 0)'
    }} transition={{
      type: 'spring',
      stiffness: 150,
      damping: 15,
      mass: 0.5
    }} data-id="element-67">
        {isHovering && <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[6px] uppercase tracking-widest text-gold font-sans" data-id="element-68">
            Дивитись
          </motion.span>}
      </motion.div>
    </>;
}